import { render, staticRenderFns } from "./outmat_return.vue?vue&type=template&id=bbb5211e&scoped=true&"
import script from "./outmat_return.vue?vue&type=script&lang=js&"
export * from "./outmat_return.vue?vue&type=script&lang=js&"
import style0 from "./outmat_return.vue?vue&type=style&index=0&id=bbb5211e&scoped=true&lang=less&"
import style1 from "./outmat_return.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb5211e",
  null
  
)

export default component.exports